/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function GoogleLogo(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'GoogleLogo',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","fillRule":"evenodd","d":"M15.455 6.545H8v3.091h4.29c-.4 1.964-2.072 3.091-4.29 3.091A4.72 4.72 0 0 1 3.273 8 4.72 4.72 0 0 1 8 3.273c1.127 0 2.145.4 2.945 1.054L13.273 2C11.855.764 10.036 0 8 0 3.564 0 0 3.564 0 8s3.564 8 8 8c4 0 7.636-2.91 7.636-8 0-.473-.072-.982-.181-1.455"}))
}
